import React from 'react'

//
import { SiteDataContext } from '../../components/page-wrapper'
import { ButtonNew, Kpi } from '../../storybook'
import { getMicroCopy } from '../../utils/microcopy'
import { getSlug } from '../../utils/slugs'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'

const ComboBodySection = ({ integration1 = {}, integration2 = {}, slugPrefix = '' }) => {
  const { title: title1, whatIsDescription: whatIsDescription1 } = integration1
  const { title: title2, whatIsDescription: whatIsDescription2 } = integration2

  const microCopyData = useMicroCopyData()
  const { lang } = React.useContext(SiteDataContext)

  return (
    <section className="l-section l-section--grey">
      <div className="l-container:12/12 l-container--default-spacing">
        <div className="l-section__content">
          <div className="l-grid l-grid--spacing:20">
            <div className="l-grid_col:12/12 l-grid__col:6/12@at:viewport-7">
              <Kpi
                title={getMicroCopy({
                  key: 'whatIsTitle',
                  data: microCopyData[lang],
                  tokens: { integration: title1 || '{integration}' }
                })}
                description={whatIsDescription1 || ''}
              >
                <ButtonNew
                  url={getSlug(integration1, slugPrefix)}
                  icon="ti-arrow-narrow-right"
                  variant={BUTTON_VARIANT.SECONDARY}
                >
                  {getMicroCopy({
                    key: 'moreAboutIntegration',
                    tokens: { integration: title1 },
                    data: microCopyData[lang]
                  })}
                </ButtonNew>
              </Kpi>
            </div>

            <div className="l-grid_col:12/12 l-grid__col:6/12@at:viewport-7">
              <Kpi
                title={getMicroCopy({
                  key: 'whatIsTitle',
                  data: microCopyData[lang],
                  tokens: { integration: title2 || '{integration}' }
                })}
                description={whatIsDescription2 || ''}
              >
                <ButtonNew
                  url={getSlug(integration2, slugPrefix)}
                  icon="ti-arrow-narrow-right"
                  variant={BUTTON_VARIANT.SECONDARY}
                >
                  {getMicroCopy({
                    key: 'moreAboutIntegration',
                    tokens: { integration: title2 },
                    data: microCopyData[lang]
                  })}
                </ButtonNew>
              </Kpi>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ComboBodySection
